












































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import store, { TransactionStore } from "../services/TransactionStore";
import TransactionItem from "@/modules/transactions/models/TransactionItem"
import Dimension from "@/modules/transactions/models/Dimension"
import CheckBox from "@/components/CheckBox.vue";
import LookupComboBox from "./LookupComboBox.vue";
import { NamedEntity } from "../models/base/NamedEntity";
import IconButton from '@/components/IconButton.vue';
import { TransactionItemInvoiceDocumentsDTO } from "../models/TransactionItemInvoiceDocuments";

// Mennyivel legyen keskenyebb a kinyíló detail-doboz (törlés-megerősítő / GENI-infó)
// a tábla látható szélességénél, hogy a jobb széle ne érjen ki a tábla széléig.
const DETAIL_BOX_INSET = 24;

interface Data {
  store: TransactionStore;
  totalTemp: number;
  currTotalTemp: number;
  isDeletion: boolean;
  headSpecDimBlockTitle: string;
  geniColumns: any[];
  geniDocuments: TransactionItemInvoiceDocumentsDTO[];
}

interface Methods {
  onRowClick(item: any): void;
  onValueChanged(item: TransactionItem): void;
  onPairChange(item: TransactionItem): void;
  rowRender(h: any, trElement: any, defaultSlots: any, props: any): any;
  dimCodes(status: number): Dimension[];
  productions(projectID: number): object[];
  onCarValueChanged(item: TransactionItem, newValue: any): void;
  onAccNoValueChanged(item: TransactionItem, newValue: any): void;
  onDimCodeValueChanged(item: NamedEntity, newValue: any): void;
  onDateValueChanged(item: TransactionItem, newValue: any): void;
  onProductionValueChanged(item: TransactionItem, newValue: any): void;
  sizeDetailBoxes(): void;
  toggleExpandRow(item: TransactionItem, isDeletionAction?: boolean, event?: Event): void;
  findRowDeleteButton(event?: Event): HTMLButtonElement | null;
  deleteItem(item: TransactionItem): void;
  setSelectedElements(item: TransactionItem): void;
  setPairElements(item: TransactionItem): void;
  onSelectedProjectUpdate(val: any, item: any): void;
  columnReorder(options: any): void;
  getGENIDocuments(item: TransactionItem): void;

}

interface Computed {
  items: TransactionItem[];
  itemsTotalValue: string;
  itemsPairValues: string;
  itemsTotalNegativeValue: string;
  itemsTotalPositiveValue: string;
  totalDisplay: string;
  currTotalDisplay: string;
  headHasSpecDim: boolean;
}

interface Props {
  positiveNegative: string;
  columns: any[];
}

export default Vue.extend<Data, Methods, Computed, Props>({
  mounted() {
    this.$emit('register-focus', [this.$refs.copyTransWDim, this.$refs.copyTrans, this.$refs.newTrans])
    // A nyitott detail-dobozok kövessék az oldal/tábla átméretezését ÉS a vízszintes görgetést.
    const gridEl = (this.$refs.itemsGrid as any)?.$el as HTMLElement | undefined;
    if (gridEl && typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(() => this.sizeDetailBoxes());
      observer.observe(gridEl);
      (this as any)._detailResizeObserver = observer;
    } else {
      window.addEventListener("resize", this.sizeDetailBoxes);
    }
    const content = gridEl ? gridEl.querySelector(".k-grid-content") : null;
    if (content) {
      content.addEventListener("scroll", this.sizeDetailBoxes, { passive: true });
      (this as any)._detailScrollEl = content;
      // A Chrome a fókuszálható gyerek nélküli görgethető konténert tab-célponttá teszi
      // (üres gridnél a Tab ide állna meg a következő vezérlő helyett) — kivesszük a tab-sorrendből.
      content.setAttribute("tabindex", "-1");
    }
  },

  beforeDestroy() {
    const observer = (this as any)._detailResizeObserver as ResizeObserver | undefined;
    if (observer) observer.disconnect();
    window.removeEventListener("resize", this.sizeDetailBoxes);
    const scrollEl = (this as any)._detailScrollEl as HTMLElement | undefined;
    if (scrollEl) scrollEl.removeEventListener("scroll", this.sizeDetailBoxes);
  },

  components: {
    MoneyDisplay,
    CheckBox,
    LookupComboBox,
    IconButton,
  },
  props: {
    positiveNegative: { type: String },
    columns: {type: Array, required: true},
  },
  data() {
    return {
      store,
      totalTemp: 0,
      currTotalTemp: 0,
      isDeletion: true,
      headSpecDimBlockTitle: "A tranzakció fejéhez már tartozik speciális dimenzió, ezért tételen nem rögzíthető. Előbb törölje a fejről!",
      geniColumns: [
        {
          cell:"selectCell",
          width: "75px"
        }, 
        {
          field: "name",
          title: "Csatolt fájl neve",
        }, 
        {
          field: "description",
          title: "Leírás",
        }, 
        {
          field: "docType",
          title: "Dokumentum típus",
        },    
      ],
      geniDocuments: [],
    };
  },
  computed: {
    // Fej↔tétel kizárás: ha a fejen van spec dim, a tétel-grid spec dim mezői nem
    // szerkeszthetők (a backend SaveTransactionItems guardja a párja).
    headHasSpecDim(): boolean {
      const t = this.store.transaction;
      return !!(t && (t.specDim1 || t.specDim2 || t.specDim3 || t.specDim4));
    },
    items(){
      //A modellhez computedben hozzáfűzöm .map-el feltételesen a selected boolean propertyt, így ki tudom jelölni a sort.
      return this.store.transactionItems.filter((x: TransactionItem) => x.accSign ==
      (
        this.$props.positiveNegative == "both" ? x.accSign : this.$props.positiveNegative == "positive" ? "K" : "T"
      )).map(item => 
        { 
          item.selected = item === this.store.selectedItem;
          item.inEdit = item === this.store.selectedItem;
          return item;
        });
    },
    // A "Teljes"/"Összepontozott" feliratok forintban jelennek meg, ezért a forintos
    // total mezőt kell összegezni, nem a devizásat (K2D f_sum.srf is a total-t összegzi,
    // és a T=K egyensúly-ellenőrzés is ezen alapul).
    itemsTotalValue(){
      return new Intl.NumberFormat('hu-HU').format(this.items.reduce((currentSumNumber: number, arrayItem: TransactionItem) => currentSumNumber + Number(arrayItem.total), 0));
    },
    itemsTotalNegativeValue(){
      return new Intl.NumberFormat('hu-HU').format(this.items.filter(x => x.accSign == "T").reduce((currentSumNumber: number, arrayItem: TransactionItem) => currentSumNumber + Number(arrayItem.total), 0));
    },
    itemsTotalPositiveValue(){
      return new Intl.NumberFormat('hu-HU').format(this.items.filter(x => x.accSign == "K").reduce((currentSumNumber: number, arrayItem: TransactionItem) => currentSumNumber + Number(arrayItem.total), 0));
    },
    itemsPairValues(){
      return new Intl.NumberFormat('hu-HU').format(this.items.filter((x: TransactionItem) => x.isHasDimensions == true).reduce((currentSumNumber: number, arrayItem: TransactionItem) => currentSumNumber + Number(arrayItem.total), 0));
    },
    totalDisplay: {
      get() {
        return this.totalTemp
          ? new Intl.NumberFormat('hu-HU',{ maximumFractionDigits: 2}).format(this.totalTemp)
          : '';
      },
      set(val) {
        const normalized = val
                .replace(/\s/g, '')      // szóközök eltávolítása
                .replace(',', '.');  
        const numeric = parseFloat(normalized);

        this.totalTemp = Number(numeric);
      }
    },
    currTotalDisplay: {
      get() {
        return this.currTotalTemp
          ? new Intl.NumberFormat('hu-HU',{ maximumFractionDigits: 2}).format(this.currTotalTemp)
          : '';
      },
      set(val) {
        const normalized = val
                .replace(/\s/g, '')      // szóközök eltávolítása
                .replace(',', '.');  
        const numeric = parseFloat(normalized);

        this.currTotalTemp = Number(numeric);
      }
    }

  },
  methods: {
    onRowClick(event){
      this.store.selectedItem = event.dataItem;
    },
    setPairElements(item){
      // Az aktív csoport a kijelölt tétel számlaszáma (invNo != 1); ezt használja az onPairChange
      // a tételek csoportba fűzéséhez.
      if(item.invNo != 1){
        this.store.selectedInvNoGroup = item.invNo;
      }
      // Az összerendelés (pontozás) a SZÁMLASZÁM (invNo) alapján áll elő, nem a kijelölés alapján:
      // azonos invNo (!= 1, és van másik tétel ugyanazzal) = egy csoport. Így minden pár egyszerre
      // látszik, nem törlődik a többi csoport egy tétel kijelölésekor. (invNo = 1 = nincs párja.)
      const counts: Record<number, number> = {};
      this.store.transactionItems.forEach((x: TransactionItem) => { counts[x.invNo] = (counts[x.invNo] || 0) + 1; });
      this.store.transactionItems.forEach((x: TransactionItem) => { x.isHasDimensions = x.invNo != 1 && counts[x.invNo] > 1; });
      // A Pontoz checkbox kattintása a Kendo rács rowclick eseményét is kiváltja (a klikk a sorban
      // buborékol), ami — mivel a store.selectedItem ilyenkor megváltozik — ugyanebben a tick-ben
      // idehívja a watcher-en keresztül ezt a metódust IS, és a fenti count-alapú újraszámítás
      // visszaállítja hamisra a frissen bepipált, még egyedüli csoporttag pipáját (mielőtt a párja
      // csatlakozna) — az onPairChange saját záró felülírását (ugyanez a szabály) ez felülírta.
      // Itt ugyanazt a kivételt alkalmazzuk, hogy a két hívási út konzisztens maradjon.
      if (item.invNo != 1) {
        item.isHasDimensions = true;
      }
    },
    setSelectedElements(item){
      if(item.accSign == "K"){
        this.store.positiveSelectedItem = item;
      }
      else{
        this.store.negativeSelectedItem = item;
      }
    },
    onValueChanged(item){
      // Accno-módban a főkönyvi szám csere NEM a normál mentés-útra megy (a store.accnoChanges térképből
      // épül a ModifyTransactionAccounts payload), ezért itt nem gyűjtjük modifiedItems-be.
      if (this.store.isAccnoEditMode)
        return

      const tItem = this.store.originalTransactionItems.find(x=> x.id === item.id)
      if (!tItem)
        return

      const fieldsToCheck: (keyof TransactionItem)[] = ['invoiceMirror','total','dim1Code','dim2Code','dim3Code','car','accDate','postCalc','bookType','remark','currency','currTotal','exchangeRate','invNo','project','productionId','specDim1','specDim2','specDim3','specDim4'] // MÁSHOVATENNI
      for (const key of fieldsToCheck) {

        if(typeof item[key] === "object" && key !='remark'){
          if((item[key] as any).id != (tItem[key] as any).id){
            const exists = this.store.modifiedItems.some(x => x.id === item.id);
            if (!exists) {
              this.store.modifiedItems.push(item);
            }
            return
          }
        }

        else if(key === 'accDate' && String(item[key]).split('T')[0] != String(tItem[key]).split('T')[0]){
          const exists = this.store.modifiedItems.some(x => x.id === item.id);
          if (!exists) {
            this.store.modifiedItems.push(item);
          }
          return
        }

        else if(item[key] != tItem[key]){
          const exists = this.store.modifiedItems.some(x => x.id === item.id);
          if (!exists) {
            this.store.modifiedItems.push(item);
          }
          return
        }
      }
      this.store.modifiedItems = this.store.modifiedItems.filter(x=> x.id !== item.id)
    },
    onPairChange(item){
      if(!store.isReadOnlyView){
        // K2D: gépi tételnél (prefix != MANU) a mentett inv_no forrásdokumentum-hivatkozás
        // (számla/MIX), nem pontozás-csoport — azt a pipa nem írhatja át.
        const original = this.store.originalTransactionItems.find(x => x.id === item.id);
        if (original && original.invNo != 1 && item.prefix != "MANU") {
          return;
        }
        if(!item.isHasDimensions == false){
          item.invNo = 1;
        }
        if(!item.isHasDimensions == true && item.invNo == 1){
          // K2D f_treff/f_max: ha nincs aktív csoport, új TRANZAKCIÓN BELÜLI csoport-azonosító
          // nyílik (max inv_no + 1 az összes tételen), és ez marad az aktív csoport, hogy a
          // következő pipa ugyanebbe fűzzön. E nélkül két friss (inv_no=1) tétel pontozásakor
          // 1 íródott 1-re, és a mentés "Nem történt módosítás."-sal tért vissza.
          if(this.store.selectedInvNoGroup == 1){
            this.store.selectedInvNoGroup = this.store.transactionItems.reduce(
              (max: number, x: TransactionItem) => Math.max(max, Number(x.invNo) || 1), 1) + 1;
          }
          item.invNo = this.store.selectedInvNoGroup;
        }
        item.isHasDimensions = !item.isHasDimensions
        // A pipák újraszámítása invNo alapján, hogy a pár mindkét tagja azonnal pipát kapjon;
        // a most bepipált, még egyedüli csoporttag pipája megmarad (a count>1 csak a párjára áll be).
        const counts: Record<number, number> = {};
        this.store.transactionItems.forEach((x: TransactionItem) => { counts[x.invNo] = (counts[x.invNo] || 0) + 1; });
        this.store.transactionItems.forEach((x: TransactionItem) => { x.isHasDimensions = x.invNo != 1 && counts[x.invNo] > 1; });
        if (item.invNo != 1) {
          item.isHasDimensions = true;
        }
      }
    },
    rowRender(h, trElement, defaultSlots, props) {
      // K2D f_jelol színezés: inv_no=1 → sárga (nincs pontozva); az AKTÍV csoport tagja → zöld;
      // más csoport tagja → törtfehér. Az aktív csoport a rákattintott csoporttag inv_no-ja
      // (setPairElements), így kattintásra átszíneződik, mint a K2D rowfocuschanging-nél.
      const invNo = props.dataItem.invNo;
      let groupClass = "";
      if (invNo === 1) {
        groupClass = "nogroup";
      } else if (props.dataItem != this.store.selectedItem) {
        groupClass = invNo == this.store.selectedInvNoGroup ? "ingroup" : "othergroup";
      }
      return h(
        trElement.tag,
        {
          ...trElement.data,
          class: [trElement.data?.class, groupClass]
        },
        trElement.children
      );
    },
    dimCodes(s){
      return this.store.dimensions.filter((i: Dimension) => i.type == s)
    },
    productions(projectID){
      if(projectID === 1)
        return this.store.pos;

      return this.store.pos.filter((i: any) => i.project == projectID)
    },
    onCarValueChanged(item,newValue){
      item.car = newValue.id;
      item.postCalc = newValue.postCalcID;

      if(newValue.postCalcPrefix == null){
        if(newValue.postCalcSeqNo == 0){
          item.seqNumber = "-"
        }else{
          item.seqNumber = newValue.postCalcSeqNo;
        }
      }
      else{
        item.seqNumber = newValue.postCalcPrefix;
      }

    },
    onAccNoValueChanged(item,newValue){
      // Accno-módban a változás a store.accnoChanges térképbe kerül: a mentés-út nem a saveTransItems,
      // hanem a ModifyTransactionAccounts parancs (másolat + sztornó), ezért a modifiedItems könyvelés
      // (onValueChanged) itt szándékosan nem fut le.
      if (store.isAccnoEditMode) {
        this.$set(store.accnoChanges, item.id, newValue.id);
      }
      item.invoiceMirror.accno = newValue.accno;
      item.invoiceMirror.id = newValue.id;
      item.invoiceMirror.dim1 = newValue.dim1;
      item.invoiceMirror.dim2 = newValue.dim2;
      item.invoiceMirror.dim3 = newValue.dim3;
      item.invoiceMirror.dim4 = newValue.dim4;
      item.invoiceMirror.dim5 = newValue.dim5;
      item.invoiceMirror.dim6 = newValue.dim6;
      item.invoiceMirror.dim7 = newValue.dim7;
      item.invoiceMirror.dim8 = newValue.dim8;
      item.invoiceMirror.dim9 = newValue.dim9;
    },
    onDimCodeValueChanged(item,newValue){
      item.id = newValue.id;
      item.name = newValue.dimcode;
    },
    onDateValueChanged(item,newValue){
      item.accDate = newValue;
    },
    onProductionValueChanged(item,newValue){
      item.productionId = newValue.id
      item.productionNumber = newValue.poNumber
      item.productionExtCode = newValue.extCode
      item.workNumber = newValue.workNumber
    },
    // A kinyíló detail-sorok (törlés-megerősítő / GENI-infó) pozicionálása. A CSS sticky a
    // Kendo tábla-DOM-ban megbízhatatlan (cellán és belső dobozon is), ezért KÉZI "sticky":
    // a doboz a tábla LÁTHATÓ szélességét veszi fel, és a grid vízszintes scroll-pozíciójával
    // toljuk el (translateX), így görgetésnél és átméretezésnél (F12) is a látótérben marad.
    // Újrahívja: sor-nyitás, a grid scroll eseménye és a ResizeObserver.
    sizeDetailBoxes(){
      const grid = this.$refs.itemsGrid as any;
      if (!grid || !grid.$el) return;
      const gridEl = grid.$el as HTMLElement;
      const content = gridEl.querySelector('.k-grid-content') as HTMLElement | null;
      const visibleWidth = (content || gridEl).clientWidth;
      const scrollLeft = content ? content.scrollLeft : 0;
      gridEl.querySelectorAll('.k-detail-cell').forEach((el) => {
        const cell = el as HTMLTableCellElement;
        // korábbi (cellára tett) sticky maradványainak törlése
        cell.style.position = "";
        cell.style.left = "";
        const box = cell.firstElementChild as HTMLElement | null;
        if (box && visibleWidth > 0) {
          // a doboz természetes kezdőpontja a hierarchia-cella után van — ennyivel kevesebbet tolunk
          const hierarchyOffset = (cell.previousElementSibling as HTMLElement | null)?.offsetWidth || 0;
          box.style.position = "";
          box.style.left = "";
          // a doboz bal széle a látótérben: amíg nem görgettünk el a hierarchia-cellán, beljebb kezdődik
          const leftInView = Math.max(0, hierarchyOffset - scrollLeft);
          // A törlés-megerősítő jobb széle ne érjen ki a tábla látható széléig (DETAIL_BOX_INSET),
          // a GENI-infó panel viszont maradjon teljes szélességű.
          const inset = box.classList.contains("detail-row") ? DETAIL_BOX_INSET : 0;
          const width = Math.max(200, visibleWidth - leftInView - inset);
          box.style.width = width + "px";
          box.style.boxSizing = "border-box";
          box.style.transform = `translateX(${Math.max(0, scrollLeft - hierarchyOffset)}px)`;
        }
      });
    },
    toggleExpandRow(item, isDeletionAction = true, event?: Event){

      // Mégse/Esc esetén a fókuszált gomb kikerül a DOM-ból, ezért még a bezárás előtt
      // eltesszük a sorhoz tartozó kuka ikont, hogy oda tudjuk visszaadni a fókuszt.
      const trashBtn = item.deleting && isDeletionAction
        ? this.findRowDeleteButton(event)
        : null;

      this.isDeletion = isDeletionAction
      item.deleting = !item.deleting

      this.$nextTick(() =>{
        this.sizeDetailBoxes();
        if(item.deleting && item.prefix == "GENI")
          this.getGENIDocuments(item);
        // Törlés-megerősítőnél a Megerősítés gomb kapja a fókuszt (Enter = törlés, Esc = mégse)
        if(item.deleting && isDeletionAction){
          const btn = (this.$el as HTMLElement).querySelector<HTMLButtonElement>(".detail-row .con_btn");
          btn?.focus();
        }
        else {
          trashBtn?.focus();
        }
      });
    },
    // A törlés-megerősítő a Kendo detail-sorában van, ami közvetlenül a saját sora után áll:
    // a megerősítőből kiindulva az előző <tr> a tétel sora, abban keressük a kuka gombot.
    findRowDeleteButton(event?: Event): HTMLButtonElement | null {
      const origin = (event?.target as HTMLElement) ?? (document.activeElement as HTMLElement);
      const masterRow = origin?.closest("tr")?.previousElementSibling as HTMLElement | null;
      return masterRow?.querySelector<HTMLElement>(".fa-trash")?.closest("button") ?? null;
    },
    deleteItem(item){
      // Törlés után a helyére lépő sor (ha az utolsót töröltük, az előző) Főkönyvi szám mezője
      // kapja a fókuszt, hogy a szerkesztés a rácson folytatható legyen.
      const visible = this.items;
      const idx = visible.indexOf(item);
      const next = visible[idx + 1] ?? visible[idx - 1] ?? null;

      this.$emit('deleteItem',item)

      if(!next){
        // Kiürült a rács: az "Új tétel létrehozás" gomb kapja a fókuszt, hogy egyből folytatható a munka.
        this.$nextTick(() => (this.$refs.newTrans as any)?.$el?.focus());
        return;
      }

      // A sor csak kijelölve szerkeszthető (inEdit), enélkül nincs is input a Főkönyvi szám cellában.
      store.selectedItem = next;
      this.$nextTick(() => {
        const field = this.$refs['firstField_' + store.transactionItems.indexOf(next)] as any;
        field?.$el?.querySelector('input')?.focus();
      });
    },
    onSelectedProjectUpdate(val,item){
      item.project.id = val.id;
      item.project.mainCode = val.mainCode;
      item.project.code = val.code;
      item.project.name = val.name;
      item.productionId = 1;
      item.productionNumber = "-"
      item.productionExtCode = "-"
      item.workNumber = "-";
    },
    columnReorder(options){
      this.$emit('columnReorder',options.columns)
    },
    async getGENIDocuments(item){
      this.geniDocuments = await store.getInvoicePictures(item.invNo);
    }
  },
  watch:{
    'store.selectedItem'(item) {
      this.totalTemp = item.total;
      this.currTotalTemp = item.currTotal;

      const accSign = this.positiveNegative == "both" ? item.accSign : this.positiveNegative == "positive" ? "K" : "T";

      if(item.accSign == accSign && (!this.store.isReadOnlyView || this.store.isAccnoEditMode)){
        this.$nextTick(() => {
          // Üres tranzakciónál a selectedItem egy alapértelmezett tétel, ami NINCS a listában
          // (indexOf = -1), így a firstField_-1 ref nem létezik — ilyenkor nincs mit fókuszálni.
          const idx = store.transactionItems.indexOf(item);
          if (idx < 0) return;
          const field = this.$refs['firstField_' + idx] as any;
          field?.$el?.querySelector('input')?.focus();
        })
      }

      if(item.accSign == accSign){
        this.setPairElements(item);
        this.setSelectedElements(item);
      }
    },
  }
});
